<template>
  <VendorBasicPage
    v-show="isShowModal"
    main-class="overflow-x-hide overflow-y-hide"
    body-class="tw-flex tw-items-center tw-justify-center tw-h-[100%]"
  >
    <div class="col-md-12 flex-container">
      <BrandPattern2 page="LOGIN" class-name="automation" />
    </div>
    <div
      class="tw-bg-white tw-w-[630px] tw-rounded-[6px] box-shadow-contain sm:tw-pl-[70px] sm:tw-pr-[216px] sm:tw-pt-[61px] sm:tw-pb-[56px] tw-p-[20px] tw-z-[1] contain-responsive"
    >
      <p class="tw-text-[#0345BD] tw-text-[26px] tw-font-semibold tw-mb-[0px]">
        {{
          getComponentUiText(
            "app-vendor-assessment-external-callback-modal-title-1",
          )
        }}
      </p>
      <p
        class="tw-text-[#231F20] tw-text-[12px] tw-font-medium tw-mt-[25px] tw-mb-[11px]"
      >
        {{
          getComponentUiText(
            "app-vendor-assessment-external-callback-modal-subtitle-1",
          )
        }}
      </p>
      <input
        id="vendor-assessment-external-callback-secret"
        data-cy="vendor-assessment-external-callback-secret"
        class="form-control form-input"
        tabindex="0"
        :placeholder="
          getComponentUiText(
            'app-user-forgot-password-enter-key-place-holder-input-text-1',
          )
        "
        @keydown.enter="submit"
        @input="(e) => (secret = e?.target?.value || '')"
      />
      <p
        class="tw-mt-[18px] tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-[150%] tw-mb-[46px]"
      >
        {{
          getComponentUiText(
            "app-vendor-assessment-external-callback-modal-hint-1",
          )
        }}
      </p>
      <button
        type="button"
        data-cy="verify-secret-key-btn"
        :class="`tw-bg-[#0345BD] tw-border-[#0345BD] ${
          !secret || secret.length < 1 ? 'btn-disabled ' : ''
        }btn btn-primary letsgo-button tw-flex tw-items-center tw-justify-center tw-h-[47px] tw-rounded-[30px] box-shafow-button tw-py-[9px] tw-px-[22px] tw-text-[18px] tw-font-semibold`"
        tabindex="3"
        :disabled="!secret || secret.length < 1"
        @click="submit"
      >
        <span v-if="!isLoadingAPI" ref="innerTextVerifyBtnRef">
          {{ getComponentUiText("app-user-verify-email-verify-button-text-1") }}
        </span>
        <span
          v-else
          :style="{ width: animationWidth + 'px' }"
          class="tw-flex tw-justify-center"
        >
          <div class="tw-h-[39px] tw-w-[39px] tw-text-[#FFF]">
            <!-- eslint-disable vue/no-unused-refs -->
            <LottieAnimation
              ref="anim"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
          </div>
        </span>
      </button>
    </div>
  </VendorBasicPage>
</template>

<script setup lang="ts">
import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import VendorBasicPage from "./vendorBasicPage.vue";
import { onBeforeMount, onBeforeUnmount, onMounted, Ref, ref } from "vue";
import Utils, { getComponentUiText } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { useRouter, useRoute } from "vue-router";
import { postExternalCallback } from "@/services/vendor";
import get from "lodash/get";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import { successStatusCodes } from "@/utils/constants";
import store from "@/store";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import { jwtDecode } from "jwt-decode";

const route = useRoute();
const token: any = ref("");
const router = useRouter();
const secret = ref("");
const isLoadingAPI = ref(false);
const innerTextVerifyBtnRef: Ref = ref(null);
const animationWidth = ref(0);
const isShowModal = ref(false);

onBeforeMount(async () => {
  const decode: any = await jwtDecode(route.query.token as string, {
    header: true,
  });
  const finalKey = await Utils.getV3Recaptcha();
  const recaptcha = await load(`${finalKey}`);
  isShowModal.value = !decode?.secretDisabled;
  if (decode?.secretDisabled) {
    router.push({
      name: "AssessmentVendorInput",
    });

    const res = await postExternalCallback(
      {
        token: route.query.token,
      },
      recaptcha,
    );
  }
});

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`);
    return await recaptcha.execute("submit");
  } catch (error: any) {
    router.push({ path: "/" });
  }
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

const submit = async () => {
  if (isLoadingAPI.value) return;
  isLoadingAPI.value = true;
  if (innerTextVerifyBtnRef.value) {
    animationWidth.value = innerTextVerifyBtnRef.value.getBoundingClientRect()[
      "width"
    ] as number;
  }
  try {
    const recaptcha = await getRecaptcha();
    token.value = route.query.token;
    const res = await postExternalCallback(
      {
        token: token.value,
        secret: secret.value,
      },
      recaptcha,
    );
    if (res.status === successStatusCodes.OK) {
      showSuccessToast(
        getComponentUiText("app-user-verify-successful-email-1"),
      );
      store.dispatch("Vendor/fetchVendorRequestedExternalInput");
    }

    // const langId = get(res, "data.data.langId", "");
  } catch (error: any) {
    isLoadingAPI.value = false;
    showErrorAPI(error, Vendor.getRequestedAssessment);
  }
};

onBeforeUnmount(() => {
  beforeUnmount();
});
</script>

<style lang="scss" scoped>
.password-reset-page {
  background: #0345bd;

  .form-control:focus {
    box-shadow: none;
  }
  .form-control::placeholder {
    color: #b7b7b7;
    font-size: 22px;
  }
}
.flex-container {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: calc(100vh - 56px);
}

.automation {
  top: 0px !important;
  height: 100% !important;
}

.box-shadow-contain {
  box-shadow: 2px 0px 20px 0px rgba(33, 31, 88, 0.1);
}

.box-shafow-button {
  box-shadow: 0px 2px 4px 0px rgba(33, 31, 88, 0.25);
}

.form-control:focus {
  box-shadow: none;
}
.form-control::placeholder {
  color: #b7b7b7;
  font-size: 22px;
  font-weight: 300;
}
.form-input {
  border: none;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  line-height: 33px;
  color: #0345bd;
  border-left: 1px solid rgba(183, 183, 183, 0.3);
  border-radius: unset;
  height: 41px !important;
  padding: 4px 0px 5px 20px !important;
}

.btn-disabled {
  background: #b7b7b7;
  color: #fff;
  border-color: #b7b7b7;
}

@media (max-width: 767px) {
  .contain-responsive {
    width: auto !important;
    padding-right: 150px;
    height: auto !important;
  }
}

@media (max-width: 600px) {
  .contain-responsive {
    padding-right: 20px;
  }
}
</style>
